module.exports = __webpack_public_path__ + "static/car2-35e8a695c104668bec05149bc162caf0.jpg";